import type { ZodObject, ZodTypeAny } from "zod";

import { z } from "zod";

export const regexSchema = (regex: RegExp, message?: string) =>
  z.string().regex(regex, message);

// parse values using the provided zod schema
export const parseSchema = <
  Values,
  Schema extends ZodTypeAny = ZodObject<{
    [P in keyof Values]: z.ZodType<Values[P]>;
  }>,
>(
  values: Values,
  schema: Schema,
): z.infer<Schema> => {
  const inputValues = schema.safeParse(values);
  if (!inputValues.success) {
    throw new Error(
      `parseSchema: invalid input values ${JSON.stringify(inputValues.error)}`,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return inputValues.data;
};
